angular.module("ainapp")
    .controller("workOrderPendingReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Work Order Pending Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })


            $scope.Init = function () {


                $('#filterModal').modal('show');
                var startdate = new Date(new Date().getFullYear(), 0, 1);


                $scope.filter = {
                    CustomerName: "",
                    ProductName: "",
                    VoucherNo: "",
                    CustomerId: "",
                    FromDate: startdate,
                    ToDate: new Date(),
                    CustomerIds: [],
                    ProductIds: [],
                    BranchId: "",

                }

                $scope.load = false;
                $scope.isFilter = false;

                $scope.CostCenters = [];
                MainService.CostCentersInReortVoucher("Packing List").then(function (response) {
                    $scope.CostCenters = response.data;
                });


            }
            $scope.Init();

            $scope.customerSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.CustomerInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectCustomerOptions = {
                placeholder: "Select Accounts...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.customerSelectDataSource
            };


            $scope.productSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.productInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectProductOptions = {
                placeholder: "Select Products...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };




            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        if ($scope.isFilter) {


                            o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                            o.data.FromDay = $scope.filter.FromDate.getDate();
                            o.data.FromYear = $scope.filter.FromDate.getFullYear();

                            o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                            o.data.ToDay = $scope.filter.ToDate.getDate();
                            o.data.ToYear = $scope.filter.ToDate.getFullYear();

                            o.data.CustomerId = $scope.filter.CustomerId;
                            o.data.VoucherNo = $scope.filter.VoucherNo;
                            o.data.ProductId = $scope.filter.ProductId;
                            o.data.BranchId = $scope.filter.BranchId;


                            o.data.CustomerIds = $scope.filter.CustomerIds;
                            o.data.ProductIds = $scope.filter.ProductIds;
                            o.data.CostCenters = $scope.CostCenters;



                            MainService.WorkOrderPendingSummaryReport(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "VoucherNumber": {
                                type: "string",
                                editable: false,
                            },
                            "Date": {
                                type: "date",
                                editable: false,
                            },
                            "TimeSheet.Month": {
                                type: "string",
                                editable: false,
                            },
                            "CustomerName": {
                                type: "string",
                                editable: false,
                            },
                            "SalesManName": {
                                type: "string",
                                editable: false,
                            },
                            "ServiceEngineerName": {
                                type: "string",
                                editable: false,
                            },
                            "WorkOrderName": {
                                type: "string",
                                editable: false,
                            },
                            "ProjectName": {
                                type: "string",
                                editable: false,
                            },
                            "ManagerName": {
                                type: "string",
                                editable: false,
                            },
                            "CreatedByName": {
                                type: "string",
                                editable: false,
                            },
                            "CustomerPONo": {
                                type: "string",
                                editable: false,
                            },
                            "GrossTotal": {
                                type: "number",
                                editable: false,
                            },
                            "LinkedValue": {
                                type: "number",
                                editable: false,
                            },
                            "BalanceValue": {
                                type: "number",
                                editable: false,
                            },
                            "InvoicedValue": {
                                type: "number",
                                editable: false,
                            },
                            "BalanceToInvoice": {
                                type: "number",
                                editable: false,
                            },
                        }
                    }
                },
                aggregate: [{
                        field: "GrossTotal",
                        aggregate: "sum"
                    },
                    {
                        field: "LinkedValue",
                        aggregate: "sum"
                        },
                    {
                        field: "BalanceValue",
                        aggregate: "sum"
                        }, {
                        field: "InvoicedValue",
                        aggregate: "sum"
                        }, {
                        field: "BalanceToInvoice",
                        aggregate: "sum"
                        }
                       ],
                //                serverPaging: true,
                //                serverSorting: true,
                //                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {
                stretch: true,
                toolbar: ["excel", "pdf"],
                selectable: true,
                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 780,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 1000,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "VoucherNumber",
                        title: "Order No #",
                        },
                    {
                        field: "WorkOrderName",
                        title: "Work Order",
                        },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "CustomerName",
                        title: "Customer",
                        },
                    {
                        field: "GrossTotal",
                        title: "Order Value",
                        template: "<div style='text-align: right'>#=kendo.toString(GrossTotal, 'n')#</div>",
                        aggregates: ["sum"],
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        },
                    {
                        field: "LinkedValue",
                        title: "WOC Value",
                        template: "<div style='text-align: right'>#=kendo.toString(LinkedValue, 'n')#</div>",
                        aggregates: ["sum"],
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        },
                    {
                        field: "BalanceValue",
                        title: "Balance WOC",
                        template: "<div style='text-align: right'>#=kendo.toString(BalanceValue, 'n')#</div>",
                        aggregates: ["sum"],
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        },
                    {
                        field: "InvoicedValue",
                        title: "Invoiced Value",
                        template: "<div style='text-align: right'>#=kendo.toString(InvoicedValue, 'n')#</div>",
                        aggregates: ["sum"],
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        },
                    {
                        field: "BalanceToInvoice",
                        title: "Balance To Be Invoiced",
                        template: "<div style='text-align: right'>#=kendo.toString(BalanceToInvoice, 'n')#</div>",
                        aggregates: ["sum"],
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        },
                    {
                        field: "SalesManName",
                        title: "Sales Man",
                        },
                    {
                        field: "ServiceEngineerName",
                        title: "Service Engineer",
                        },
                    {
                        field: "ServiceTypeName",
                        title: "Service Type",
                        },
                    {
                        field: "ProjectName",
                        title: "Project Name",
                        },
                    {
                        field: "CustomerPONo",
                        title: "Customer PO",
                        },
                    {
                        field: "ManagerName",
                        title: "Manager",
                        },
                    {
                        field: "CreatedByName",
                        title: "Created By",
                        },
                ],
            };



            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.Refresh = function () {
                $scope.Init();
                $scope.isFilter = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            //            $scope.print = function () {
            //
            //                $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
            //                $scope.filter.FromDay = $scope.filter.FromDate.getDate();
            //                $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();
            //
            //                $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
            //                $scope.filter.ToDay = $scope.filter.ToDate.getDate();
            //                $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();
            //
            //                $scope.filter.CostCenters = $scope.CostCenters;
            //
            //                MainService.PrintTimeSheetReport($scope.filter).then(function (response) {
            //                    if (response.data != null) {
            //                        $window.open(config.basePath + "/Reports/" + response.data, "_blank");
            //                    } else {
            //                        toastr.error("Network Error");
            //                    }
            //                    $scope.Load = false;
            //                }, function (err) {
            //                    toastr.error("Network Error");
            //                    $scope.Load = false;
            //                })
            //            }


        }])
